import { TID } from "@/lib/testIds";

const services = [
  "International Ocean Freight",
  "International Air Freight",
  "Road Transportation",
  "Customs Brokerage",
  "Warehousing & Distribution",
  "Project Logistics",
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={TID.footer.container}
      className="bg-blue-950 text-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="mb-5">
              <img
                src="/jmr-logo.png?v=2"
                alt="JMR Global Logistics — Your Freight, Our Priority"
                className="h-24 md:h-28 w-auto brightness-0 invert"
              />
            </div>
            <p className="font-display font-black text-3xl md:text-4xl tracking-tighter leading-tight max-w-md">
              Your Freight, <span className="text-sky-400">Our Priority.</span>
            </p>
            <p className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-sky-400">
              Moving Global Trade Forward
            </p>
            <p className="mt-5 text-slate-300 max-w-md text-base leading-relaxed">
              International Freight Forwarding · Air Freight · Ocean Freight · Road Transport · Customs Brokerage · Project Logistics.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-sky-400 mb-4">Solutions</p>
            <ul className="space-y-3 text-base text-slate-300">
              {services.map((s) => (
                <li key={s} className="hover:text-sky-400 transition-colors cursor-default">{s}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-sm font-bold uppercase tracking-[0.25em] text-sky-400 mb-4">Reach Us</p>
            <ul className="space-y-3 text-base text-slate-300">
              <li><a href="tel:+919884003957" className="hover:text-sky-400">+91 98840 03957</a></li>
              <li><a href="mailto:info@jmrgloballogistics.com" className="hover:text-sky-400">info@jmrgloballogistics.com</a></li>
              <li>Chennai, India · Head Office</li>
              <li>London, United Kingdom · Branch</li>
              <li>Middle East · Planned Expansion</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 md:mt-28 -mb-6 select-none">
          <p className="font-display font-black text-white/[0.05] text-[16vw] md:text-[14vw] leading-none tracking-tighter text-center">
            JMR GLOBAL LOGISTICS
          </p>
        </div>

        <div className="border-t border-white/10 pt-6 mt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-sm text-slate-400">
          <p>© {year} JMR Global Logistics. All Rights Reserved.</p>
          <p className="font-mono tracking-widest uppercase">INDIA · UNITED KINGDOM · MIDDLE EAST</p>
        </div>
      </div>
    </footer>
  );
}
